import { useState } from "react"
import axios from "axios"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { fetchCart } from "../../data/CartSlice"
import { useAuth } from "../../data/useAuth"

export const useOrderPayment = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { user } = useAuth()
  const [isPlacingOrder, setIsPlacingOrder] = useState(false)

  const initiatePayment = async (
    productId = null,
    qty = 1,
    addressId = null
  ) => {
    setIsPlacingOrder(true)
    try {
      // 1️⃣ Place order (individual or cart)
      const res = await axios.post("/api/orders/place-order", {
        product_id: productId,
        qty,
        address_id: addressId,
      })
      console.log("Order placed successfully:", res.data)
      const { order_id, razorpay_order_id, amount, currency } = res.data

      // 2️⃣ Setup Razorpay options
      const options = {
        key: import.meta.env.VITE_RAZORPAY_KEY_ID,
        amount: amount,
        currency: currency,
        name: "Dr. Malu Mahendran",
        description: "Order Payment",
        order_id: razorpay_order_id,
        handler: async function (response) {
          try {
            setIsPlacingOrder(true)
            // 3️⃣ Verify payment
            await axios.post("/api/orders/verify-payment", {
              order_id: order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            })

            // 4️⃣ Refresh Redux cart state (empties cart in UI)
            dispatch(fetchCart())

            // 5️⃣ Redirect to order page directly
            navigate(`/orders/${order_id}`)
          } catch (verifyError) {
            console.error("Payment verification failed", verifyError)
            alert("Payment verification failed. Please contact support.")
          } finally {
            setIsPlacingOrder(false)
          }
        },
        modal: {
          ondismiss: function () {
            setIsPlacingOrder(false)
          },
        },
        prefill: {
          name: user?.name || "Customer",
          email: user?.email || "customer@example.com",
          contact: user?.phone_number || "9999999999",
        },
        theme: { color: "#3399cc" },
      }

      // 5️⃣ Open Razorpay checkout
      const rzp = new window.Razorpay(options)
      rzp.open()
    } catch (err) {
      console.error(err)
      alert("Payment initiation failed. Please try again.")
      setIsPlacingOrder(false)
    }
  }

  return { initiatePayment, isPlacingOrder }
}
